import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor } from './httpInterceptor.service';
import { ConfigService } from './config.service';
import { SessionHandlerService } from './sessionHandler.service';
import { CommonConstants } from '../utilities/commonConstants';

export interface PolicyExpiryForm {
    policyExpiryDay: number,
    policyExpiryMonth: number,
    policyExpiryYear: number
}
@Injectable({
    providedIn: 'root'
})
export class VehicleDetailService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandler: SessionHandlerService
    ) { }
    public GetQuoteDetails(data: any) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.modifyPlansGetQuote;
        return this._httpInterceptor.Post(url, data, true);
    }
    public GetUpdatedIDVDetails(data: any) {
        const url = (ConfigService.getInstance().getConfigObject().APIURL.refinements);
        console.log(url);
        return this._httpInterceptor.Post(url, data, true);
    }
    public comparePlans(variantCode1: any, variantCode2: any) {
        let url = (ConfigService.getInstance().getConfigObject().APIURL.comparePlan);
        url = url + variantCode1 + '&variantCode2=' + variantCode2;
        return this._httpInterceptor.Get(url);
    }
    public GetCityList() {
        const url = (ConfigService.getInstance().getConfigObject().APIURL.getCitiesApi);
        return this._httpInterceptor.Get(url);
    }
    public GetVehicleInfoList(type: string) {
        const url = (ConfigService.getInstance().getConfigObject().APIURL.getVehicleInfoList.concat(type));
        return this._httpInterceptor.Get(url);
    }
    public GetVehicleDetails(url): Observable<ActivitiModel.MTResponse<any>> {
        return this._httpInterceptor.Get(url, true);
    }
    public GetInsuranceProviders() {
        const url = ConfigService.getInstance().getConfigObject().APIURL.insuranceproviders;
        return this._httpInterceptor.Get(url, true);
    }
    public PostCallService(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.postCallVehicleDetails;
        url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
        return this._httpInterceptor.Post(url, data);
    }
    public GetCallService() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getCallVehicleDetails;
        url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
        return this._httpInterceptor.Get(url);
    }
    public getNomineeDetails() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.nomineeDetails;
        url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
        url = url.replace('{quoteId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId));
        return this._httpInterceptor.Get(url);
    }
    public postNomineeDetails(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.nomineeDetails;
        url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
        url = url.replace('{quoteId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId));
        return this._httpInterceptor.Post(url, data);
    }
    public getRelationship() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getRelationship;
        return this._httpInterceptor.Get(url);
    }

    public getRtoCodeDetailsList(rtoCode: any) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getRtoCodeDetails;
        url = url.replace('{rtoCode}',rtoCode);
        url = url.replace('{rtoName}','');
        return this._httpInterceptor.Get(url);
    }

    public checkBhSeriesPattern(value) {
        return CommonConstants.vehicleRegistrationPattern.bhSeriesPattern.test(value.toUpperCase()) ? true : false;
    }

    public validatePolicyExpiryDate(policyExpiryFormValue: PolicyExpiryForm, policyExpiryDate:Date) {
        if (!policyExpiryFormValue) { return null; }
        const day = Number(policyExpiryFormValue.policyExpiryDay);
        const month = Number(policyExpiryFormValue.policyExpiryMonth);
        const year = Number(policyExpiryFormValue.policyExpiryYear);
        if (year < 2000) {
            return CommonConstants.policyYearLessThanErrMsg;
        }
        // Validate actual calendar date using JS Date rollover: if day/month don't match
        // back from the constructed date, the input is invalid (e.g. 29/02/2026, 30/02/2026)
        const constructed = new Date(year, month - 1, day);
        if (
            constructed.getFullYear() !== year ||
            constructed.getMonth() !== month - 1 ||
            constructed.getDate() !== day
        ) {
            return CommonConstants.policyDateInvalidErrMsg;
        }
        return '';
    }

    public validateDate(policyExpiryFormValue: PolicyExpiryForm, policyExpiryDate: Date) {
        if (!policyExpiryFormValue) { return null; }
        if(Object.values(policyExpiryFormValue).includes('')) {
            return 'This is a mandatory field.';
        } else if (new Date(policyExpiryDate).toLocaleDateString() === 'Invalid Date') {
            return CommonConstants.policyDateInvalidErrMsg;
        } else {
            return 'This is a mandatory field.';
        }
    }
}
